import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { useSession } from '@sdk/session/SessionContext';
import { Article, ArticleComment } from '@sdk/newsfeed/types/apiTypes';

import { mapAPIArticleToUI, mapAPIArticleCommentToUI } from '../utils/mappers';

export const useNewsfeedMappers = () => {
  const { currentUser } = useSession();
  const personaCollection = usePersonaCollection();

  // INFO session context is guaranteed to have loaded data
  // personas is not and can be empty
  const isReady = personaCollection.users?.length > 0;

  return useMemo(
    () => ({
      isReady,
      mapAPIArticleToUI: (article: Article) =>
        mapAPIArticleToUI({ article, currentUser, personaCollection }),
      mapAPIArticleCommentToUI: (comment: ArticleComment) =>
        mapAPIArticleCommentToUI({ comment, currentUser, personaCollection }),
    }),
    [currentUser, isReady, personaCollection]
  );
};
